/* Blog post enhancements: TOC build/scroll-spy, share copy, mobile TOC toggle. */
(function () {
  'use strict';

  function slugify(text) {
    return String(text)
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function ensureUniqueId(el, used) {
    var base = el.id || slugify(el.textContent || '');
    if (!base) return;
    var id = base;
    var n = 2;
    while (used.has(id)) {
      id = base + '-' + n++;
    }
    used.add(id);
    el.id = id;
  }

  function getArticleBody() {
    return document.querySelector('.article-template__content');
  }

  function buildTOC() {
    var tocEl = document.querySelector('[data-article-toc]');
    if (!tocEl) return;
    var listEl = tocEl.querySelector('[data-toc-list]');
    if (!listEl) return;

    var body = getArticleBody();
    if (!body) {
      tocEl.style.display = 'none';
      return;
    }

    var headings = body.querySelectorAll('h2, h3');
    var used = new Set();
    Array.prototype.forEach.call(document.querySelectorAll('[id]'), function (el) {
      used.add(el.id);
    });

    // Always assign IDs to headings — needed for both auto + manual TOC anchor links.
    Array.prototype.forEach.call(headings, function (h) {
      if (!h.id) ensureUniqueId(h, used);
      else used.add(h.id);
    });

    // Auto mode: build list items from headings.
    if (tocEl.getAttribute('data-auto') === 'true') {
      if (!headings.length) {
        tocEl.style.display = 'none';
        return;
      }
      var html = '';
      var idx = 0;
      Array.prototype.forEach.call(headings, function (h) {
        if (h.tagName === 'H2') idx += 1;
        var levelClass = h.tagName === 'H3' ? ' article-toc__item--h3' : '';
        var indexLabel = h.tagName === 'H2' ? ('0' + idx).slice(-2) : '';
        html +=
          '<li class="article-toc__item' +
          levelClass +
          '">' +
          '<a class="article-toc__link" href="#' +
          h.id +
          '" data-toc-link>' +
          (indexLabel ? '<span class="article-toc__index">' + indexLabel + '</span>' : '<span class="article-toc__index"></span>') +
          '<span class="article-toc__label">' +
          (h.textContent || '').replace(/</g, '&lt;') +
          '</span>' +
          '</a>' +
          '</li>';
      });
      listEl.innerHTML = html;
    }

    setupScrollSpy(tocEl, body);
    setupMobileToggle(tocEl);
  }

  function setupScrollSpy(tocEl, body) {
    var links = tocEl.querySelectorAll('[data-toc-link]');
    if (!links.length) return;

    var linkByHash = {};
    Array.prototype.forEach.call(links, function (a) {
      var hash = a.getAttribute('href');
      if (hash && hash.charAt(0) === '#') linkByHash[hash.slice(1)] = a;
    });

    var targets = [];
    Object.keys(linkByHash).forEach(function (id) {
      var t = document.getElementById(id);
      if (t) targets.push(t);
    });
    if (!targets.length) return;

    if ('IntersectionObserver' in window) {
      var visible = new Set();
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) visible.add(e.target.id);
            else visible.delete(e.target.id);
          });
          // Pick topmost visible heading
          var topmost = null;
          var topY = Infinity;
          targets.forEach(function (t) {
            if (visible.has(t.id)) {
              var y = t.getBoundingClientRect().top;
              if (y < topY) {
                topY = y;
                topmost = t.id;
              }
            }
          });
          Array.prototype.forEach.call(links, function (a) {
            a.classList.remove('is-active');
          });
          if (topmost && linkByHash[topmost]) {
            linkByHash[topmost].classList.add('is-active');
          }
        },
        { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
      );
      targets.forEach(function (t) {
        io.observe(t);
      });
    }
  }

  function setupMobileToggle(tocEl) {
    var titleEl = tocEl.querySelector('.article-toc__title');
    if (!titleEl) return;
    function syncCollapsed() {
      if (window.matchMedia('(max-width: 989px)').matches) {
        if (!tocEl.hasAttribute('data-collapsed')) {
          tocEl.setAttribute('data-collapsed', 'true');
        }
      } else {
        tocEl.removeAttribute('data-collapsed');
      }
    }
    syncCollapsed();
    window.addEventListener('resize', syncCollapsed);
    titleEl.addEventListener('click', function () {
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      var isCollapsed = tocEl.getAttribute('data-collapsed') === 'true';
      if (isCollapsed) tocEl.removeAttribute('data-collapsed');
      else tocEl.setAttribute('data-collapsed', 'true');
    });
  }

  function setupCopyLinkButtons() {
    var btns = document.querySelectorAll('[data-copy-link]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-link');
        if (!url) return;
        var label = btn.querySelector('[data-copied-state]');
        var done = function () {
          if (label) {
            label.hidden = false;
            setTimeout(function () {
              label.hidden = true;
            }, 1800);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {
            fallbackCopy(url);
            done();
          });
        } else {
          fallbackCopy(url);
          done();
        }
      });
    });
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } catch (_) {}
    document.body.removeChild(ta);
  }

  function init() {
    buildTOC();
    setupCopyLinkButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
